import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import './Comment.css';

import formatDate from '../../../public Func/DateFix';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from '../../../public Func/axiosAuth';
import Markdown from '../../../components/Markdown/Markdown';
import MarkdownEditor from '../../../components/Markdown/MarkdownEditor';
import { shouldClampComment } from '../../../utils/markdownUtils';

function PostCommentBox({commentData}) {
    //// Report Part
    const [somthingElse,setsomthingElse] = useState(false)
    const [showReportModal, setShowReportModal] = useState(false)
    const [selectedReason, setSelectedReason] = useState(null)
    const [showErrorMessage,setshowErrorMessage] = useState(null)

    //// Edit Part (only for the admin's own comments)
    const [isEditing, setIsEditing] = useState(false)
    const [editText, setEditText] = useState(commentData.comment || '')
    const [isSavingEdit, setIsSavingEdit] = useState(false)
    const [editError, setEditError] = useState(null)

    //// Clamping. A comment is a short field in a long list, so anything past
    //// COMMENT_CLAMP_CHARS of rendered text collapses to two lines and grows in place.
    //// Measured on the rendered text, clamped in lines: cutting the Markdown source
    //// mid-syntax would leave literal `[text](http://...` fragments in the preview.
    const [bodyExpanded, setBodyExpanded] = useState(false)

    function bodyClassName(){
        if(!shouldClampComment(commentData.comment)) return 'commentMarkdown'
        return bodyExpanded
            ? 'commentMarkdown commentMarkdownExpanded'
            : 'commentMarkdown commentMarkdownClamp'
    }

    function showEditForm(){
        setEditText(commentData.comment || '')
        setEditError(null)
        setIsEditing(true)
    }

    function hideEditForm(){
        setIsEditing(false)
        setEditError(null)
    }

    async function saveEdit(){
        const text = editText.trim()
        if (!text){
            setEditError('Comment cannot be empty.')
            return
        }
        setIsSavingEdit(true)
        setEditError(null)
        try {
            const res = await axios.post(process.env.REACT_APP_BACKEND_URL + '/admin/edit-comment', {
                commentID: commentData.id,
                comment: text,
            })
            if(res.status === 200 && (res.data === 'Done' || res.data?.done || res.data?.message === 'Done')){
                commentData.comment = text
                commentData.edited = true
                setIsEditing(false)
                // force re-render for the updated text + (edited) tag
                setTick(t => t + 1)
            } else {
                setEditError(res.data || 'Failed to edit comment. Please try again.')
            }
        } catch(err){
            console.error('Error editing comment:', err)
            setEditError(err.response?.data || 'Failed to edit comment. Please try again.')
        } finally {
            setIsSavingEdit(false)
        }
    }

    // force re-render helper used after local edits
    const [tick, setTick] = useState(0)

    // Hiding the Popup Window
    function hideReportForm(){
        setShowReportModal(false)
        setTimeout(() => {
            setsomthingElse(false)
            setshowErrorMessage(null)
            setSelectedReason(null)
        }, 300)
    }

    // Showing the Popup Window
    function ShowPopupReportForm(){
        setShowReportModal(true)
        setsomthingElse(false)
        setshowErrorMessage(null)
        setSelectedReason(null)
    }

    // Choose a Reason
    function SelectReportReason(event){
        const reason = event.currentTarget.innerHTML
        setSelectedReason(reason)
        if(reason === 'Somthing Else'){
            setsomthingElse(true)
        }else{
            setsomthingElse(false)
        }
    }

    // Submit the Form
    async function submitReportForm(event){
        var reason = ''
        // Data Reading and Validation
        if (selectedReason === null){
            setshowErrorMessage('You Have To Choose a Reason')
            return;
        }
        reason = selectedReason
        if (selectedReason === 'Somthing Else'){
            const inputValue = event.currentTarget.parentElement.querySelector("input").value
            if (inputValue === ''){
                setshowErrorMessage('You Have To Write a Reason')
                return
            }
            reason = inputValue
        }
        setshowErrorMessage(null)
        try{
            hideReportForm()

            const parent = document.getElementById('comment-' + commentData.id)
            if (parent) {
                parent.style.height =  parent.scrollHeight+"px"
                function hideScroll(){
                    parent.style.height = '0px'
                    parent.style.padding = '0px'
                    parent.style.margin = '0px auto'
                }
                function dissolve(){
                    parent.style.display = 'none'
                }
                axios.delete(process.env.REACT_APP_BACKEND_URL+"/super/post-comment",{data:{commentID:commentData.id,patientID:commentData.patientID,reason:reason}}).then((res)=>{
                    setTimeout(hideScroll, 100)
                    setTimeout(dissolve, 2000)
                }).catch((err)=>{
                    console.log("Error!!\n",err)
                })
            }
        }catch(err){
            console.log("Error!!\n",err)
        }

    }
    return (
        <div className='PostCommentBox' id={'comment-' + commentData.id}>
            <div className='CommentHeader'>
                <div  className='UserPic'>
                    {commentData.isAdmin ? (
                        <div className='anonymous'>
                            <FontAwesomeIcon icon="fa-solid fa-user-shield" />
                        </div>
                    ) : (
                        <img src={commentData.authorProfileImage || commentData.patientProfileImage || commentData.doctorProfileImage} alt={commentData.authorName || commentData.patientName || commentData.doctorName} />
                    )}
                    {!commentData.isAdmin && (commentData.isDoctor && commentData.doctorID ? 
                        <a href={"./profile/doctor/"+commentData.doctorID} target="_blank" rel="noreferrer" className='profileLink'></a> :
                        (commentData.patientID ? <a href={"./profile/patient/"+commentData.patientID} target="_blank" rel="noreferrer" className='profileLink'></a> : '')
                    )}
                </div>
                
            </div>
            <div className='CommentData'>
                <div className='NameAndDate'>
                    <p className='UserName'>
                        {commentData.authorName || commentData.doctorName || commentData.patientName}
                        {commentData.isAdmin && (
                            <FontAwesomeIcon className='CommentAdminBadge' icon="fa-solid fa-user-shield" />
                        )}
                        {!commentData.isAdmin && (commentData.authorTitle || commentData.doctorTitle ? ` - ${commentData.authorTitle || commentData.doctorTitle}` : '')}
                    </p>
                    <span className='GrayText'>{formatDate(commentData.date)}{commentData.edited ? ' (edited)' : ''}</span>
                </div>
                <div className='CommentBody'>
                    {isEditing ? (
                        <div className='CommentEditArea'>
                            <MarkdownEditor
                                value={editText}
                                onChange={setEditText}
                                rows={3}
                                ariaLabel='Comment'
                            />
                            <div className='CommentEditActions'>
                                <span className='CommentEditCancel' onClick={hideEditForm}>Cancel</span>
                                <span className={'CommentEditSave' + (isSavingEdit ? ' disabled' : '')} onClick={saveEdit}>
                                    {isSavingEdit ? 'Saving...' : 'Save'}
                                </span>
                            </div>
                            {editError && <p className='CommentEditError'>{editError}</p>}
                        </div>
                    ) : (
                        <>
                            <Markdown data-testid="comment-body" className={bodyClassName()}>{commentData.comment}</Markdown>
                            {shouldClampComment(commentData.comment) && (
                                <button
                                    className='commentReadMore'
                                    onClick={() => setBodyExpanded(previous => !previous)}
                                    aria-expanded={bodyExpanded}
                                >
                                    {bodyExpanded ? 'Show less' : 'Read more'}
                                </button>
                            )}
                        </>
                    )}
                </div>
                
            </div>
            <div className='PostCommentKeys'>
                {commentData.isOwnComment && (
                    <div className='PostCommentEdit' onClick={showEditForm}>
                        Edit
                    </div>
                )}
                {!commentData.isAdmin && (
                    <div className='PostCommentReport' onClick={ShowPopupReportForm}>
                        Report
                    </div>
                )}
                <div className='PostCommentReactions'>
                    <FontAwesomeIcon icon="fa-solid fa-heart" /> {commentData.reactions}

                </div>
            </div>

            {showReportModal && ReactDOM.createPortal(
                <div className='ReportPopupWindow'>
                    <div className='backgroundBlock' onClick={hideReportForm}></div>
                    <div className='ReportForm'>
                        <h1 className='TitleReport'>Report Comment</h1>
                        <h3 className='ForNextPost'>Comment Content:</h3>
                        <Markdown className="commentMarkdown">{commentData.comment}</Markdown>
                        <div className='ReportTagOptions'>
                            <span className={'ReportTag' + (selectedReason === 'Spam' ? ' selected' : '')} onClick={SelectReportReason}>Spam</span>
                            <span className={'ReportTag' + (selectedReason === 'Nudity' ? ' selected' : '')} onClick={SelectReportReason}>Nudity</span>
                            <span className={'ReportTag' + (selectedReason === 'Scam' ? ' selected' : '')} onClick={SelectReportReason}>Scam</span>
                            <span className={'ReportTag' + (selectedReason === 'Illigal' ? ' selected' : '')} onClick={SelectReportReason}>Illigal</span>
                            <span className={'ReportTag' + (selectedReason === 'Sucide or Self-injury' ? ' selected' : '')} onClick={SelectReportReason}>Sucide or Self-injury</span>
                            <span className={'ReportTag' + (selectedReason === 'Violance' ? ' selected' : '')} onClick={SelectReportReason}>Violance</span>
                            <span className={'ReportTag' + (selectedReason === 'Hate Speech' ? ' selected' : '')} onClick={SelectReportReason}>Hate Speech</span>
                            <span className={'ReportTag' + (selectedReason === 'Somthing Else' ? ' selected' : '')} onClick={SelectReportReason}>Somthing Else</span>
                        </div>
                        <div className={'ReasonInputForm'+(somthingElse?" show":"")}>
                            <h2>Reason:</h2>
                            <p>Write a Simple Message For the Report Reason</p>
                            <input type='text' placeholder='Write the Message'/>
                        </div>
                        <button className='submutReportButton' onClick={submitReportForm}>Submit Report</button>
                        <p className={'ErrorMessage'+(showErrorMessage?" show":"")}>{showErrorMessage}</p>
                    </div>
                </div>,
                document.body
            )}
        </div>
    );
}

export default PostCommentBox;